import http from "./index"
function getData(params) {
    return http.post('/article/where', params)
}

function editData(params) {
    return http.put('/article', params)
}

function getBannerList(params) {
    return http.post('/home/kingname/getKingBanner', params)
}

//获取火逸科技官网首页轮播图
function getBannerLists(params) {
    return http.post('/banner/selectKingBanner', params)
}

function getArticleData(params) {
    return http.get(`/article/querybyid?id=${params}`)
}

export default {
    getArticleData,
    getData,
    editData,
    getBannerList,
    getBannerLists
}


// WEBPACK FOOTER //
// ./src/api/api.js